import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import store from "./redux/store";
import { ToastContainer } from "react-toastify";
import "react-notifications/lib/notifications.css";
import { NotificationContainer } from "react-notifications";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
    <ToastContainer autoClose={2000} position="top-center" />
    <NotificationContainer />
  </Provider>
  // </React.StrictMode>
);
